module.exports = __webpack_public_path__ + "static/media/Pesquisar.852d9b3a.svg";